import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { LocalStorage,WindowService } from '@public/core';

@Component({
  templateUrl: './cookie-dialog.component.html',
  styleUrls: ['./cookie-dialog.component.scss'],
  imports: [MatButtonModule, MatDialogModule]
})
export class CookieDialogComponent {
  constructor(
    protected windowService: WindowService,
    private storage: LocalStorage,
    private dialog: MatDialogRef<CookieDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ok() {
    this.storage.set('cookiesAccepted', new Date().toISOString());
    this.dialog.close();
  }
}
